export default __webpack_public_path__ + "static/media/asana-logo.44b145d9.png";